import { css, keyframes,useTheme } from "@emotion/react";
import React, { ReactNode } from 'react';
import { UpsunTheme } from "@upsun/react-component-library/src/themes";
import colorsDark from "@upsun/react-component-library/src/styles/colors-dark";
import colorsLight from "@upsun/react-component-library/src/styles/colors-light";
import { pxToRem, mediaQueries, weights } from "@upsun/react-component-library/src/styles/css-utils";

type SidebarCalloutProps = {
  children: ReactNode,
  icon: "leaf" | "percent",
};

type SidebarIconProps = {
  name: "leaf" | "percent"
}

const SidebarIcon: React.FC<SidebarIconProps> = ({name}) => {
  const theme = useTheme() as UpsunTheme;
  const colorDark = colorsDark.HighlightStrongBgStrong;
  const colorLight = colorsLight.HighlightStrongBgStrong;

  switch (name) {
    case "leaf":
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.30017 19.7C4.50017 19.9 4.70017 20 5.00017 20C5.30017 20 5.50017 19.9 5.70017 19.7L7.50017 17.9C8.40017 18.3 9.70017 18.7 11.1002 18.7C12.7002 18.7 14.4002 18.2 16.0002 16.7C19.4002 13.3 20.0002 5.4 20.0002 5.1C20.0002 4.8 19.9002 4.5 19.7002 4.3C19.5002 4.1 19.2002 4 18.9002 4C18.6002 4 10.5002 4.8 7.30017 8C5.30017 10 5.00017 12.4 5.40017 14.4L11.4002 11.1L4.20017 18.3C3.90017 18.7 3.90017 19.3 4.30017 19.7Z" fill={theme.name === "light" ? colorLight : colorDark} />
        </svg>
      );
    case "percent":
      return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.65166 6.5473C3.65166 5.77459 3.9607 5.03352 4.51081 4.48712C5.06092 3.94073 5.80702 3.63376 6.58499 3.63376H7.91832C8.69285 3.63332 9.43578 3.32864 9.98499 2.78619L10.9183 1.85915C11.1909 1.58687 11.515 1.37079 11.872 1.22335C12.2289 1.0759 12.6117 1 12.9983 1C13.3849 1 13.7677 1.0759 14.1247 1.22335C14.4816 1.37079 14.8057 1.58687 15.0783 1.85915L16.0117 2.78619C16.5609 3.32864 17.3038 3.63332 18.0783 3.63376H19.4117C20.1896 3.63376 20.9357 3.94073 21.4858 4.48712C22.0359 5.03352 22.345 5.77459 22.345 6.5473V7.87164C22.3454 8.64095 22.6522 9.37886 23.1983 9.92436L24.1317 10.8514C24.4058 11.1222 24.6233 11.4441 24.7718 11.7986C24.9202 12.1532 24.9966 12.5334 24.9966 12.9174C24.9966 13.3014 24.9202 13.6816 24.7718 14.0361C24.6233 14.3907 24.4058 14.7126 24.1317 14.9833L23.1983 15.9104C22.6522 16.4559 22.3454 17.1938 22.345 17.9631V19.2874C22.345 20.0601 22.0359 20.8012 21.4858 21.3476C20.9357 21.894 20.1896 22.201 19.4117 22.201H18.0783C17.3038 22.2014 16.5609 22.5061 16.0117 23.0485L15.0783 23.9756C14.8057 24.2479 14.4816 24.4639 14.1247 24.6114C13.7677 24.7588 13.3849 24.8347 12.9983 24.8347C12.6117 24.8347 12.2289 24.7588 11.872 24.6114C11.515 24.4639 11.1909 24.2479 10.9183 23.9756L9.98499 23.0485C9.43578 22.5061 8.69285 22.2014 7.91832 22.201H6.58499C5.80702 22.201 5.06092 21.894 4.51081 21.3476C3.9607 20.8012 3.65166 20.0601 3.65166 19.2874V17.9631C3.65121 17.1938 3.34446 16.4559 2.79832 15.9104L1.86499 14.9833C1.59086 14.7126 1.37331 14.3907 1.22487 14.0361C1.07642 13.6816 1 13.3014 1 12.9174C1 12.5334 1.07642 12.1532 1.22487 11.7986C1.37331 11.4441 1.59086 11.1222 1.86499 10.8514L2.79832 9.92436C3.34446 9.37886 3.65121 8.64095 3.65166 7.87164V6.5473Z" fill="#D5F800" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8.98535 16.8777L16.9854 8.93164" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9.65202 10.256C10.0202 10.256 10.3187 9.95951 10.3187 9.59381C10.3187 9.2281 10.0202 8.93164 9.65202 8.93164C9.28383 8.93164 8.98535 9.2281 8.98535 9.59381C8.98535 9.95951 9.28383 10.256 9.65202 10.256Z" fill="black" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16.318 16.8771C16.6862 16.8771 16.9847 16.5806 16.9847 16.2149C16.9847 15.8492 16.6862 15.5527 16.318 15.5527C15.9498 15.5527 15.6514 15.8492 15.6514 16.2149C15.6514 16.5806 15.9498 16.8771 16.318 16.8771Z" fill="black" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
  }
}

const SidebarCallout: React.FC<SidebarCalloutProps> = ({children, icon, ...props }) => {
  const theme = useTheme() as UpsunTheme;

  const colorDark = colorsDark.HighlightStrongBgStrong;
  const colorLight = colorsLight.HighlightStrongBgStrong;

  const fadingRainbow = keyframes`
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 0 100%;
    }
  `;

  const calloutStyles = css`
    position: relative;
    margin-bottom: ${pxToRem(32)};
    padding-left: ${pxToRem(32)};
    text-align: left;

    &::before {
      content: '';
      position: absolute;
      top: ${pxToRem(icon === 'leaf' ? 26 : 32)};
      left: ${pxToRem(10)};
      bottom: ${pxToRem(8)};
      width: ${pxToRem(2)};
      background-image: linear-gradient(
        0deg,
        #6046FF 0%,
        #ED49F0 25%,
        #FF4A11 50%,
        #D5F800 100%
      );
      background-size: 100% 400%;
      animation: ${fadingRainbow} 4s linear infinite alternate;

      ${mediaQueries.lg} {
        top: ${pxToRem(icon === 'leaf' ? 30 : 36)};
      }
    }

    svg {
      position: absolute;
      top: 0;
      left: 0;
      width: ${pxToRem(24)};
      height: ${pxToRem(24)};

      ${mediaQueries.lg} {
        top: ${pxToRem(4)};
      }
    }

    h3 {
      font: inherit;
      font-weight: ${weights.bold};
      color: ${theme.name === "light" ? colorLight : colorDark};
      margin-bottom: ${pxToRem(8)};
    }
  `;

  return (
    <div css={calloutStyles} {...props}>
      <SidebarIcon name={icon} />
      {children}
    </div>
  );
};

export default SidebarCallout;
